import * as Roles from '@/store/roles';

export const todoItemActionsPermissions = {
  addTodoItem: [Roles.Any],
  deleteTodoItem: [Roles.Any],
  getTodoItem: [Roles.Any],
  getTodoItems: [Roles.Any],
  loadSelectedPartTodoItems: [Roles.Any],
  saveTodoItemProperties: [Roles.Any],
  setTodoItemProperties: [Roles.Any],
  syncTodoItem: [Roles.Any],
};



// WEBPACK FOOTER //
// ./src/store/todoItem/todoItemActionsPermissions.js